import { render, staticRenderFns } from "./BillList.vue?vue&type=template&id=65c818f3&scoped=true"
import script from "./BillList.vue?vue&type=script&lang=js"
export * from "./BillList.vue?vue&type=script&lang=js"
import style0 from "./BillList.vue?vue&type=style&index=0&id=65c818f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c818f3",
  null
  
)

export default component.exports